import React from "react";
import {cn} from "../../lib/Utils";

interface SimpleLinkProps {
    name: string;
    href: string;
    classNames?: string;
}


export const SimpleLink = ({name, href, classNames} : SimpleLinkProps) => {
    return (
        <a
            href={href}
            className={cn("text-base font-medium text-ink-200 hover:text-ember-400 transition-colors", classNames)}
        >
            {name}
        </a>
    );
};
